const moduleKey = "factoryDashboardPage";

export const factoryDashboardPageEn = {
  [moduleKey]: {
    title: "Factory Dashboard",
  },
};

export const factoryDashboardPagePtBr = {
  [moduleKey]: {
    title: "Painel da fábrica",
  },
};

export const factoryDashboardPageDe = {
  [moduleKey]: {
    title: "Fabrik-Dashboard",
  },
};

export const factoryDashboardPageZhHans = {
  [moduleKey]: {
    title: "工厂仪表板",
  },
};

export const factoryDashboardPageIt = {
  [moduleKey]: {
    title: "Dashboard di Fabbrica",
  },
};

export const factoryDashboardPageEs = {
  [moduleKey]: {
    title: "Panel de Fabrica",
  },
};

export const factoryDashboardPageNl = {
  [moduleKey]: {
    title: "Fabrieksdashboard",
  },
};

export const factoryDashboardPageTr = {
  [moduleKey]: {
    title: "Fabrika Kontrol Paneli",
  },
};
